module.exports = __webpack_public_path__ + "static/img/AE@3x.db15267a.jpg";